import { render, staticRenderFns } from "./LegacyTelephoneField.vue?vue&type=template&id=17143f82&"
import script from "./LegacyTelephoneField.vue?vue&type=script&lang=js&"
export * from "./LegacyTelephoneField.vue?vue&type=script&lang=js&"
import style0 from "./LegacyTelephoneField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports